import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface ICustomerRequestsService {
  token: string;
  requestType?: string;
  key?: string;
  companyCode?: string;
  reqBody?: ReqBodyType;
  requestId?: string;
}

class CustomerRequestsService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_NEST_API ?? '', false);
  }

  getCustomerRequestsData = async ({
    token,
    requestType,
    key,
    companyCode,
  }: ICustomerRequestsService) => {
    return this.httpClient.get({
      token,
      path: `/customers-requests?requestType=${requestType}&key=${key}&companyCode=${companyCode}`,
    });
  };

  getAllCustomersRequests = async ({
    token,
  }: ICustomerRequestsService) => {
    return this.httpClient.get({
      token,
      path: '/customers-requests/all',
    });
  };

  createCustomerRequest = async ({
    token,
    reqBody,
  }: ICustomerRequestsService) => {
    return this.httpClient.post({
      token,
      path: '/customers-requests',
      reqBody,
    });
  };

  acceptRequest = async ({
    token,
    requestId,
  }: ICustomerRequestsService) => {
    return this.httpClient.post({
      token,
      path: `/customers-requests/accept/${requestId}`,
    });
  };

  rejectRequest = async ({
    token,
    requestId,
  }: ICustomerRequestsService) => {
    return this.httpClient.post({
      token,
      path: `/customers-requests/reject/${requestId}`,
    });
  };
}

export default new CustomerRequestsService();
